import { useCallback, useMemo, useState } from "react";

export const useSoundPlayer = () => {
  const [soundFile, setSoundFile] = useState<HTMLAudioElement>(new Audio());

  const play = useCallback(
    (audio: string, delay = 0) => {
      const file = soundFile || new Audio(audio);
      if (file.src !== audio) {
        file.pause();
        file.src = audio;
        file.load();
      } else if (!file.paused) return;
      window.setTimeout(() => {
        file.play();
        setSoundFile(file);
      }, delay);
    },
    [soundFile]
  );

  const playOnce = useCallback((audio: string, delay = 0) => {
    const file = new Audio(audio);
    window.setTimeout(() => {
      file.load();
      file.play();
      setSoundFile(file);
    }, delay);
  }, []);

  return useMemo(() => ({ play, playOnce }), []);
};

export function getRandomIntInclusive(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}
